import React from 'react';
import { useState } from 'react';
import {
    Stack,
    TextField,
    Button,
} from '@shopify/polaris';
import { GenieTag } from './GenieTag';
import {
    CirclePlusMajor
} from '@shopify/polaris-icons';

function TagListComponent(props) {

    const [query, setQuery] = useState(null);
    const handleQueryChange = (_) => setQuery(_);
    const handleClearQuery = (_) => setQuery("");
    const hasNoMatchingAction = props.actionOnNoMatching != null;
    const handleNoMatchingAction = () => {
        const handled = props.actionOnNoMatching(query);

        if (handled) {
            setQuery("");
        }
    };

    let tags = props.tags
        .filter(tag => query == null || tag.toUpperCase().includes(query.toUpperCase()))
        .map((tag) => <GenieTag key={tag} state={props.tagDisplayState} onClick={props.onTagClick} onRemove={props.onTagRemove}>{tag}</GenieTag>);
    const noMatchingTags = props.tags.length > 0 && tags.length === 0;
    let noMatchingTagsUI = (<div>
        {hasNoMatchingAction && <Stack alignment='center' distribution='leading' wrap spacing='tight'>
            <Stack.Item>
                <Button size='slim' plain icon={CirclePlusMajor} onClick={handleNoMatchingAction}>{`Add "${query}" as new tag`}</Button>
            </Stack.Item>
        </Stack>
        }
        <Stack alignment='center' distribution='center' wrap spacing='tight'>
            <Stack.Item>
                <br />
                <span>No tags found</span>
                <br />
            </Stack.Item>
        </Stack>
    </div>);

    if (props.onProvideNoMatchingTagsUI != null) {
        noMatchingTagsUI = props.onProvideNoMatchingTagsUI(query);
    }

    return (<div>
        {props.enableSearch && <div>
            <TextField
                placeholder={props.searchBoxPlaceholder}
                value={query}
                onChange={handleQueryChange}
                clearButton
                onClearButtonClick={handleClearQuery}
                autoComplete="off"
            />
            <br />
        </div>
        }
        <Stack alignment='center' distribution='leading' wrap spacing='tight'>
            {tags}
        </Stack>
        {noMatchingTags && noMatchingTagsUI}
    </div >);

}

TagListComponent.defaultProps = {
    searchBoxPlaceholder: "Filter tags",
    enableSearch: false,
    actionOnNoMatching: null,
    onTagClick: null,
    onTagRemove: null,
    tags: [],
    tagDisplayState: "default"
}

export default TagListComponent;